module.exports = __webpack_public_path__ + "img/ad1.e64e8f5e.png";